import { Directive, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import * as Utils from '../../utils';

@Directive({
    selector: '[directive-input-regexp]', /* [directive="regexp"] */
})
export class InputRegexpDirective {
    @Input() public regexp: RegExp = /./;

    constructor(
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit() { }

    @HostListener('keyup', ['$event']) public onKeyUp(e: KeyboardEvent) {
        /* Android fix */
        if (Utils.Inputs.isKeySafe(e)) return;
        const elem: HTMLInputElement = this._elementRef.nativeElement;

        this._renderer2.setValue(elem, (elem.value ? elem.value.split('') : []).reduce((acc, char) => {
            if (!this.regexp.test(char)) {
                return acc;
            }
            return acc += char;
        }, ''));
    }

    @HostListener('keydown', ['$event']) public onKeyDown(e: KeyboardEvent): void {
        if (Utils.Inputs.isKeySafe(e)) return;

        if (!this.regexp.test(`${e.key}`)) {
            e.preventDefault();
        }
    }
}
